import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FaAward } from 'react-icons/fa'

const certifications = [
  {
    id: 1,
    title: 'Certified ASP.NET Developer',
    issuer: 'Meta',
    year: '2023',
    description:
      'Advanced certification in modern ASP.NET development practices.',
    flip: 'flip-left',
  },
  {
    id: 2,
    title: 'AWS Certified Solutions Architect',
    issuer: 'Amazon Web Services',
    year: '2022',
    description:
      'Expertise in cloud infrastructure and architectural best practices.',
    flip: 'flip-right',
  },
  {
    id: 3,
    title: 'Google UX Design Certificate',
    issuer: 'Google',
    year: '2021',
    description:
      'Comprehensive understanding of user experience design and research.',
    flip: 'flip-left',
  },
]

export default function Certifications() {
  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  return (
    <section id="certifications" className="py-24 px-6 sm:px-12 lg:px-20">
      <h2 className="text-lg leading-7">My Recognitions</h2>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl">
        Certifications & Achievements
      </p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {certifications.map((cert) => (
          <div
            key={cert.id}
            className="group relative ring-2 ring-base-300 bg-base-200 rounded-2xl shadow-xl p-6"
            data-aos={cert.flip}
          >
            <div className="flex items-center gap-4">
              <FaAward className="text-4xl text-yellow-500" />
              <div>
                <h3 className="text-xl font-bold text-base-content">
                  {cert.title}
                </h3>
                <p className="text-sm text-gray-400">
                  {cert.issuer} - {cert.year}
                </p>
              </div>
            </div>
            <p className="mt-4 text-sm text-gray-500">{cert.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
